import { render, staticRenderFns } from "./QuestionInput.vue?vue&type=template&id=820582ac&scoped=true&"
import script from "./QuestionInput.vue?vue&type=script&lang=js&"
export * from "./QuestionInput.vue?vue&type=script&lang=js&"
import style0 from "./QuestionInput.vue?vue&type=style&index=0&id=820582ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820582ac",
  null
  
)

export default component.exports